import * as React from 'react';
import { createContext, useContext } from 'react';

/**
 * These are the contexts that the teacher application can be in.
 *
 * Socrative: launched through b.socrative.com
 * ShowbieAssessments: launched inside of the showbie application (web or ios)
 */
export enum TeacherApplicationContext {
  /** Launched through b.socrative.com */
  Socrative = 'socrative',
  /** Launched inside of the showbie application (web or ios) */
  ShowbieAssessments = 'showbie_assessments',
}

export const TeacherApplicationContextContext = createContext<
  TeacherApplicationContext | undefined
>(undefined);

interface TeacherApplicationContextProviderProps {
  children: React.ReactNode;
  applicationContext: TeacherApplicationContext;
}

/**
 * Provides a way for application to be aware of the context it is in.
 */
export const TeacherApplicationContextProvider = ({
  children,
  applicationContext,
}: TeacherApplicationContextProviderProps) => {
  return (
    <TeacherApplicationContextContext.Provider value={applicationContext}>
      {children}
    </TeacherApplicationContextContext.Provider>
  );
};

export function useTeacherApplicationContext() {
  const applicationContext = useContext(TeacherApplicationContextContext);
  if (applicationContext === undefined) {
    throw new Error('TeacherApplicationContextContext not found');
  }
  return applicationContext;
}
